import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Product} from '../models/product';

@Injectable({
  providedIn: 'root'
})
export class ProductResolver implements Resolve<Product[]> {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Product[]> {
    const list: Product[] = [
      {
        productId: 14,
        imageUrl: 'https://voxcred.com.br/img/cartao-adesao-tenda-pf.png',
        title: 'Cartão Tenda - Pessoa Física'
      }, {
        productId: 15,
        imageUrl: 'https://voxcred.com.br/img/cartao-tenda_funcionario.png',
        title: 'Cartão Tenda - Funcionário'
      }, {
        productId: 16,
        imageUrl: 'https://voxcred.com.br/img/cartao-adesao-tenda-pj.png',
        title: 'Cartão Tenda - Pessoa Jurídica'
      },
    ];

    return of(list);
  }
}
